import React, { useEffect } from "react";
import { useAuth, useNavigation } from "react-uicomp";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getCurrentResearchAction } from "../../../../actions/Actions";
import { getCurrentLanguage } from "../../../../utils/getCurrentLanguage.util";
import ActivityIndicator from "../../../hoc/activityIndicator/ActivityIndicator.hoc";

// import PLACEHOLDER from "../../../../assets/icons/arsp_placeholder.png";
import PLACEHOLDER from "../../../../assets/images/placeholder.png";
import { FILE_URL } from "../../../../config/Config";

const mapStateToProps = (state) => {
  return {
    currentResearch: state.currentResearch,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCurrentResearchAction }, dispatch);
};

const ResearchList = [
  {
    title: "Farm Management and Research Support Project",
    leader: "Dr. Govinda Prasad Timsina",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
  },
  {
    title: "Farm Management and Research Support Project",
    leader: "Dr. Govinda Prasad Timsina",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
  },
  {
    title: "Farm Management and Research Support Project",
    leader: "Dr. Govinda Prasad Timsina",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
  },
  {
    title: "Farm Management and Research Support Project",
    leader: "Dr. Govinda Prasad Timsina",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
  },
  {
    title: "Farm Management and Research Support Project",
    leader: "Dr. Govinda Prasad Timsina",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
  },
  {
    title: "Farm Management and Research Support Project",
    leader: "Dr. Govinda Prasad Timsina",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
  },
  {
    title: "Farm Management and Research Support Project",
    leader: "Dr. Govinda Prasad Timsina",
    image:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
  },
];

export const Study = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props) => {
  const { getCurrentResearchAction, currentResearch } = props;
  const { listLoader, list } = currentResearch;
  const { setHeaderTitle, language } = useAuth();
  const { params, navigation } = useNavigation();
  const { navigate } = navigation;
  const currentLanguage = getCurrentLanguage(language);

  useEffect(() => {
    setHeaderTitle(language.key.research);
  }, [setHeaderTitle, language.key.research]);

  useEffect(() => {
    getCurrentResearchAction();
  }, [getCurrentResearchAction]);

  // console.log("list current research", list);
  return (
    <div className="research-study-wrapper">
      <div className="container">
        <div className="content-wrapper">
          <div className="title">Current Research Projects</div>
          <ActivityIndicator animating={listLoader}>
            <div className="study-wrapper">
              {list.length > 0 ? (
                list.map((val, index) => {
                  const title = val?.title;
                  const leader = val?.description?.shortDesc?.en;
                  const thumbnail = val?.thumbnail;

                  return (
                    <div className="study" key={index}>
                      <div
                        className="study-image"
                        style={{
                          backgroundImage: `url(${
                            thumbnail ? FILE_URL + thumbnail : PLACEHOLDER
                          })`,
                        }}></div>

                      <div className="study-title">{title}</div>

                      <div className="study-description">{leader}</div>
                    </div>
                  );
                })
              ) : (
                <p style={{ textAlign: "center" }}>No Data Available</p>
              )}
            </div>
          </ActivityIndicator>
        </div>
      </div>
    </div>
  );
});
